import styled from 'styled-components';

import { base } from '../../../styles';

export const StyledTabContent = styled.div`
    padding: 0 52px;
`;
